import { memoize } from 'lodash'

export default memoize(string => string.split('\n').join('<br />'))
